import React from 'react';
import { StyledButton } from '../style';
export var ChangePhoneAction = function (_a) {
    var onPhoneChange = _a.onPhoneChange;
    return (React.createElement(StyledButton, { type: "button", onClick: onPhoneChange }, "Change mobile phone number"));
};
//# sourceMappingURL=index.js.map